import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginUI from "../components/LoginUI";
import { useUser } from '../../context/UserContext';

const URL = process.env.REACT_APP_API_URL;
const REMEMBER_LOGIN_KEY = "vyonta_remember_login";

export default function Login() {
  const { loginEmpresa } = useUser();
  const navigate = useNavigate();

  const [nombre, setNombre] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberLogin, setRememberLogin] = useState(false);

  useEffect(() => {
    const rememberedName = localStorage.getItem(REMEMBER_LOGIN_KEY);
    if (rememberedName) {
      setNombre(rememberedName);
      setRememberLogin(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 1. Hacer login (esto crea la cookie HttpOnly)
      const loginRes = await fetch(`${URL}/api/empresa/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include", // IMPORTANTE: incluir cookies
        body: JSON.stringify({ nombre: nombre.trim(), password }),
      });
      if (!loginRes.ok) throw new Error("Login failed");

      // 2. Obtener los datos de la empresa del endpoint
      const { user } = await loginRes.json();

      // 3. Guardar en sessionStorage
      const empresaData = {
        id: user.id,           // ID de la empresa
        empresa_id: user.id,
        nombre: user.nombre,   // Nombre de la empresa
        usuario_empresa: user.usuario_empresa,
        loginTime: new Date().getTime(),
      };

      // ✅ ACTUALIZAR CONTEXTO (Esto dispara el cambio en App.js)
      loginEmpresa(empresaData);

      if (rememberLogin) {
        localStorage.setItem(REMEMBER_LOGIN_KEY, nombre.trim());
      } else {
        localStorage.removeItem(REMEMBER_LOGIN_KEY);
      }

      // Navegar
      navigate('/inicio', { replace: true });

    } catch (err) {
      console.error(err);
      setError(true);
    } setPassword("");
  }


const handleNombreChange = (e) => {
  setNombre(e.target.value);
  if (error) setError(false);
};

const handlePasswordChange = (e) => {
  setPassword(e.target.value);
  if (error) setError(false);
};

const handleShowPassword = () => {
  setShowPassword(!showPassword);
};

const handleRememberLoginChange = (e) => {
  const checked = e.target.checked;
  setRememberLogin(checked);
  if (!checked) {
    localStorage.removeItem(REMEMBER_LOGIN_KEY);
  }
};

return (
  <LoginUI
    usuario={nombre}
    password={password}
    error={error}
    showPassword={showPassword}
    onUsuarioChange={handleNombreChange}
    onPasswordChange={handlePasswordChange}
    rememberLogin={rememberLogin}
    onRememberLoginChange={handleRememberLoginChange}
    onSubmit={handleSubmit}
    handleShowPassword={handleShowPassword}
  />
);
}
